import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";
import { scrollToTop } from "@/hooks/useScrollToTop";

interface ArticleCardProps {
  article: Article;
  horizontal?: boolean;
}

export default function ArticleCard({ article, horizontal }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      onClick={scrollToTop}
      className={`group block w-full rounded-xl bg-background-800/60 hover:bg-background-800 transition-colors overflow-hidden border border-background-200/20 ${
        horizontal ? "flex flex-col sm:flex-row" : ""
      }`}
    >
      <div
        className={`overflow-hidden ${horizontal ? "sm:w-56 sm:shrink-0 aspect-video sm:aspect-auto" : "aspect-video w-full"}`}
      >
        <img
          src={article.cover}
          alt={`${article.title} 文章配图`}
          title={`${article.title} 抖漫资讯`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className={`flex flex-col ${horizontal ? "p-4 sm:p-5 flex-1" : "p-4"}`}>
        <div className="flex items-center gap-2 mb-2">
          <span className="px-2 py-0.5 rounded bg-background-700 text-primary-400 text-xs whitespace-nowrap">
            {article.categoryName}
          </span>
          <span className="text-xs text-foreground-600 whitespace-nowrap">{article.readTime}阅读</span>
        </div>
        <h3 className="font-medium text-foreground-50 group-hover:text-primary-400 transition-colors text-sm md:text-base leading-snug line-clamp-2">
          {article.title}
        </h3>
        {!horizontal && (
          <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
            {article.summary}
          </p>
        )}
        <div className="mt-auto pt-3 flex items-center justify-between text-xs text-foreground-600">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {article.views}
          </span>
        </div>
      </div>
    </Link>
  );
}